// API configuration - uses relative URLs for production compatibility
// When REACT_APP_BACKEND_URL is empty, fetch() uses the current origin automatically

export const getApiUrl = () => {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  // If empty or not set, return empty string (relative URL)
  // This makes fetch('/api/...') work on any domain
  console.log("ENV URL:", process.env.REACT_APP_BACKEND_URL);
  return envUrl || '';
};

export const API_URL = getApiUrl();
